// src/feedbackMessages.js

const feedbackMessages = [
    {
      range: [0, 25],
      message: 'Thank you for completing the digital wellbeing assessment. Your results indicate that you are just starting your journey in cultivating a positive digital wellbeing environment at home, enhancing family communication about digital wellbeing and AI, building parental resourcefulness and confidence, and strengthening school-parent communication. This is a great place to begin, and with focus and support, you can gradually develop effective habits and strategies that support your family\'s healthy and balanced digital life. Remember, every small step forward counts, and we’re here to help you along the way.',
      actions: [
        {
          text: 'Try Alice, AI Parenting Tech Coach for Parents',
          label: 'Meet Alice',
          href: 'https://digital-parenting-assistant.kigulab.com/',
        },
        {
          text: 'Visit Our Digital Parenting Resource Hub',
          label: 'Visit Digital Parenting Hub',
          href: 'https://www.kigumigroup.com/parenting-in-an-ai-age-articles',
        },
        {
          text: 'Subscribe to our Parenting in an AI Age newsletter',
          label: 'Subscribe to Newsletter',
          href: 'https://miladevenport.substack.com/p/parenting-in-an-ai-age-11-july-2025?r=1sxor5',
        },
        {
          text: 'Register your school for our education platform KiguLab to teach your children about digital wellbeing and AI ethics',
          label: 'Get KiguLab',
          href: 'https://www.kigumigroup.com/kigulab',
        },
      ],
    },
    {
      range: [26, 50],
      message: 'Thank you for completing the digital wellbeing assessment. Your results show that you have taken important first steps toward creating a healthier digital environment at home and fostering family conversations about digital wellbeing and AI. While you’ve begun building confidence in managing these challenges and engaging with your child’s school, there is still significant opportunity for growth. With continued effort and support, you can strengthen your skills and resources to create a more balanced and connected digital experience for your family. We’re here to guide you every step of the way.',
      actions: [
        {
          text: 'Try Alice, AI Parenting Tech Coach for Parents',
          label: 'Meet Alice',
          href: 'https://digital-parenting-assistant.kigulab.com/',
        },
        {
          text: 'Visit Our Digital Parenting Resource Hub',
          label: 'Visit Digital Parenting Hub',
          href: 'https://www.kigumigroup.com/parenting-in-an-ai-age-articles',
        },
        {
          text: 'Subscribe to our Parenting in an AI Age newsletter',
          label: 'Subscribe to Newsletter',
          href: 'https://miladevenport.substack.com/p/parenting-in-an-ai-age-11-july-2025?r=1sxor5',
        },
        {
          text: 'Register your school for our education platform KiguLab to teach your children about digital wellbeing and AI ethics',
          label: 'Get KiguLab',
          href: 'https://www.kigumigroup.com/kigulab',
        },
      ],
    },
    {
      range: [51, 75],
      message: 'Thank you for completing the digital wellbeing assessment. Your results show that you have the beginnings of a good foundation in supporting a positive digital environment at home, fostering open family conversations about digital wellbeing and AI, and demonstrating resourcefulness and confidence as a parent. Additionally, your engagement with school-parent communication is off to a good start. With some focused effort, you can solidify these areas to enhance your family’s overall digital wellbeing.',
      actions: [
        {
          text: 'Try Alice, AI Parenting Tech Coach for Parents',
          label: 'Meet Alice',
          href: 'https://digital-parenting-assistant.kigulab.com/',
        },
        {
          text: 'Visit Our Digital Parenting Resource Hub',
          label: 'Visit Digital Parenting Hub',
          href: 'https://www.kigumigroup.com/parenting-in-an-ai-age-articles',
        },
        {
          text: 'Register your school for our education platform KiguLab to teach your children about digital wellbeing and AI ethics',
          label: 'Get KiguLab',
          href: 'https://www.kigumigroup.com/kigulab',
        },
      ],
    },
    {
      range: [76, 99],
      message: 'Thank you for completing the Digital Wellbeing Diagnostic Assessment. Your results indicate that you have a strong foundation in supporting digital wellbeing within your family, especially in creating a positive environment at home and engaging in open communication about digital habits and AI. You also demonstrate effective resourcefulness and confidence as a parent, along with active involvement in school-parent communication. To continue building on this excellent base, we encourage you to explore new strategies and resources that can further enhance your family’s digital wellbeing in today\'s rapidly evolving digital landscape.',
      actions: [
        {
          text: 'Try Alice, AI Parenting Tech Coach for Parents',
          label: 'Meet Alice',
          href: 'https://digital-parenting-assistant.kigulab.com/',
        },
        {
          text: 'Register your school for our education platform KiguLab to teach your children about digital wellbeing and AI ethics',
          label: 'Get KiguLab',
          href: 'https://www.kigumigroup.com/kigulab',
        },
      ],
    },
  ];

  export default feedbackMessages;
